import { NgModule } from '@angular/core';
import {CommonModule, DatePipe, LowerCasePipe} from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import {IonicModule} from '@ionic/angular';
// modules
import { SharedModule } from 'src/app/shared/shared.module';
// containers
import { HomeGroupComponent } from './containers/home-group/home-group.component';


const routes: Routes = [
  { path: '', component: HomeGroupComponent }
];

@NgModule({
  declarations: [HomeGroupComponent],
  providers: [DatePipe, LowerCasePipe],
  imports: [CommonModule, RouterModule.forChild(routes), IonicModule, SharedModule]
})
export class HomeGroupModule {}
